import React from 'react';
import styled from 'styled-components';
import ScheduledJobCard from './ScheduledJobCard';

const JobsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const ScheduledJobsList = ({ scheduledJobs, calculateRemainingTime, isNodeSchedule }) => {
    return (
      <JobsContainer>
        {scheduledJobs.length > 0 ? (
          scheduledJobs.map(job => (
            <ScheduledJobCard
              key={job.menu_id || job.nextInvocation}
              job={job}
              calculateRemainingTime={calculateRemainingTime}
              isNodeSchedule={isNodeSchedule}
            />
          ))
        ) : (
          <p>스케줄된 작업이 없습니다.</p>
        )}
      </JobsContainer>
    );
  };

export default ScheduledJobsList;